"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Builder = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var styles = _interopRequireWildcard(require("./Builder.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Builder = props => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles['builder']
  }, /*#__PURE__*/React.createElement(_uiKit.Avatar, {
    src: props.avatar,
    size: 42,
    type: "builder"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['info']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, {
    fontWeight: "bold"
  }, props.name), /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "gray40_100"
  }, props.title))), /*#__PURE__*/React.createElement("div", {
    className: styles['statistic']
  }, props.housesStatistic));
};
exports.Builder = Builder;